import { useEffect, useRef, useState } from 'react';

export default function StorySection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 md:py-32 px-6 md:px-16 lg:px-24 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          <div className={`w-full lg:w-1/2 transition-all duration-1000 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
            <div className="aspect-[3/4] w-full max-w-md mx-auto lg:mx-0 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20perfume%20bottle%20collection%20on%20marble%20surface%20warm%20golden%20light%20minimalist%20luxury%20fragrance%20design%20glass%20and%20gold%20details&width=600&height=450&seq=about-gallery-1&orientation=landscape"
                alt="Colección de fragancias"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className={`w-full lg:w-1/2 transition-all duration-1000 delay-200 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
            <p className="text-xs uppercase tracking-[0.25em] text-gray-400 mb-6">Nuestra Historia</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 leading-tight">
              Tradición y Vanguardia en Cada Nota
            </h2>
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>
                Desde Bogotá, Colombia, Esencia&co. ha forjado un legado como la mayor
                distribuidora de insumos para perfumería fina de Latinoamérica. Combinamos
                décadas de experiencia con una red logística de vanguardia para abastecer
                a perfumerías, laboratorios y emprendedores con los mejores materiales del
                mercado.
              </p>
              <p>
                Nuestro equipo de especialistas trabaja con proveedores selectos de todo el
                mundo, asegurando materias primas de excelencia que permiten a nuestros
                clientes crear composiciones únicas. Cada envío es una garantía de calidad,
                puntualidad y acompañamiento profesional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}